import { createRecord } from '@/entities/shared/record/create-record';
import type { ShoppingItem } from '../schemas/shopping-item';
import { shoppingItemSchema } from '../schemas/shopping-item';

export async function createShoppingItem(data: Partial<ShoppingItem>): Promise<string> {
  return createRecord('shopping', shoppingItemSchema, data);
}
